module.exports = __webpack_public_path__ + "img/smile1.1.27f5625a.svg";